var css = {"closeButtonContainer":"VideoPlayerModal-module_closeButtonContainer__-7ose","customPlayIcon":"VideoPlayerModal-module_customPlayIcon__hX3zd","video_container":"VideoPlayerModal-module_video_container__VFkny","playIconHover":"VideoPlayerModal-module_playIconHover__HDbNW","playIcon":"VideoPlayerModal-module_playIcon__gouqA"};

export { css as default };
